import { SvgIcon } from '../../Icon';
import KubitTooltip from '../../KubitTooltip';
import { useCentralChartSettingContext } from '../CentralChartSetting/contexts/CentralChartSettingContext';
import { ChartHeaderIconWrapper } from './ChartHeaderUI';

const CentralChartSettingToggle = () => {
  const { isCentralChartSettingOpen, setIsCentralChartSettingOpen } =
    useCentralChartSettingContext();

  const handleClick = () => {
    setIsCentralChartSettingOpen(!isCentralChartSettingOpen);
  };

  return (
    <KubitTooltip content={'Toggle Chart Configuration'} placement="bottom-end">
      <ChartHeaderIconWrapper
        size={24}
        onClick={handleClick}
        $isActive={isCentralChartSettingOpen}
      >
        <SvgIcon name={'gear'} width={16} height={16} />
      </ChartHeaderIconWrapper>
    </KubitTooltip>
  );
};

export default CentralChartSettingToggle;
